'use client';

import { useId } from 'react';

/**
 * Gradient shield mark + "FRAUDdefender" wordmark, ported from the design
 * handoff (`brand.jsx`). `useId` keeps the gradient id unique per instance so
 * multiple marks on one page don't share/clobber a `<defs>` gradient.
 */

export function LogoMark({ size = 30 }: { size?: number }) {
  const gradientId = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" style={{ flexShrink: 0 }} aria-hidden>
      <defs>
        <linearGradient id={gradientId} x1="4" y1="2" x2="28" y2="30" gradientUnits="userSpaceOnUse">
          <stop stopColor="oklch(0.74 0.14 240)" />
          <stop offset="1" stopColor="oklch(0.52 0.18 262)" />
        </linearGradient>
      </defs>
      <path
        d="M16 2.3c2.7 2.1 6 3.4 9.2 3.6.9 0 1.6.8 1.6 1.7v8.1c0 6.8-4.6 10.3-10.2 12.2a1.6 1.6 0 0 1-1.1 0C9.9 28 5.2 24.5 5.2 17.7V7.6c0-.9.7-1.7 1.6-1.7C10 5.7 13.3 4.4 16 2.3Z"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M11.3 16.2l3.1 3.1 6.1-6.4"
        stroke="white"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Logo({ size = 30, fontSize = 18 }: { size?: number; fontSize?: number }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, fontSize, fontWeight: 600 }}>
      <LogoMark size={size} />
      <span style={{ letterSpacing: '-0.01em' }}>
        FRAUD<b style={{ color: 'var(--primary-2)', fontWeight: 700 }}>defender</b>
      </span>
    </span>
  );
}
